
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// classes
import { DataState } from '@/core/classes/DataState.class'

// types
import { CityT } from '@/core/types/cities.types'

//realisations
import { cities } from '@/core/realisations/cities.realisation'

// constants
import { CALLS_TYPE_OPTIONS } from '@/core/constants/calls.constants'

export default defineComponent({
    components: {
        TheButton,
        TheSelect,
        TheInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reset', 'search'],
    setup(props, { emit }) {
        const filters_state = reactive({
            courierName: null as string | null,
            search: null as string | null,
            type: null as number | null,
            phone: null as string | null,
            createdAtFrom: null as string | null,
            createdAtTo: null as string | null,
            cityId: null as number | null,
            clientName: null as string | null,
        })

        const data_state = reactive({
            cities: new DataState<CityT>({}),
        })

        const reset = () => {
            if (props.loading) return

            filters_state.courierName = null
            filters_state.search = null
            filters_state.type = null
            filters_state.phone = null
            filters_state.createdAtFrom = null
            filters_state.createdAtTo = null
            filters_state.cityId = null
            filters_state.clientName = null

            emit('reset')
        }

        const search = () => {
            if (props.loading) return

            emit('search', { ...filters_state })
        }

        //

        const loadCities = async (page: number, search?: string) => {
            data_state.cities.pagination.current_page = page

            try {
                data_state.cities.is_loading = true

                const data = await cities.getAllList(page, search)
                data_state.cities.list = data.data

                data_state.cities.pagination.total_pages = data.meta.last_page

                data_state.cities.is_failed = false
                data_state.cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.cities.failure.catchError(error)

                if (!data_state.cities.failure.error_state.is_cancel) {
                    data_state.cities.is_failed = true
                }
            } finally {
                if (!data_state.cities.failure.error_state.is_cancel) {
                    data_state.cities.is_loading = false
                }
            }
        }

        const loadMoreCities = async (page: number) => {
            if (page > data_state.cities.pagination.total_pages) return
            data_state.cities.pagination.current_page = page

            try {
                data_state.cities.is_loading = true

                const response = await cities.getAllList(page)
                data_state.cities.list = data_state.cities.list.concat(response.data)

                data_state.cities.pagination.total_pages = response.meta.last_page

                data_state.cities.is_failed = false
                data_state.cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.cities.failure.catchError(error)

                if (!data_state.cities.failure.error_state.is_cancel) {
                    data_state.cities.is_failed = true
                }
            } finally {
                if (!data_state.cities.failure.error_state.is_cancel) {
                    data_state.cities.is_loading = false
                }
            }
        }

        const searchCity = (search_query: string) => {
            // data_state.from_cities.pagination.current_page
            loadCities(1, search_query)
        }

        const unshiftFindedCity = async (city: CityT) => {
            await loadCities(data_state.cities.pagination.current_page)
            data_state.cities.list.unshift(city)
        }

        //

        onBeforeMount(() => {
            loadCities(1)
        })

        return {
            filters_state,
            data_state,
            //
            reset,
            search,
            //
            loadCities,
            loadMoreCities,
            searchCity,
            unshiftFindedCity,
            //
            CALLS_TYPE_OPTIONS,
        }
    },
})
